import { Component } from '@angular/core';
import { TimelineMax, Power2, Quad } from 'gsap';
import * as CustomWiggle from '../../../assets/gsap/plugins/CustomWiggle';
import * as CustomBounce from '../../../assets/gsap/plugins/CustomBounce';
import { CbsBasicsComponent } from '../animation-base-classes/cbs-basics.component';
import { IconService } from '../../core/icon.service';
import { params as paramsStill } from './still.params';
import { params as paramsSocial } from './social.params';
import { params as paramsVideo } from './video.params';
import * as _ from 'lodash';
import * as d3 from 'd3';
import {BasicChartComponent} from '../animation-base-classes/basic-chart.component';

@Component({
  selector: 'app-triptych-line-hor-steps',
  templateUrl: './triptych-line-hor-steps.component.html',
  styleUrls: ['./triptych-line-hor-steps.component.scss']
})
export class TriptychLineHorStepsComponent extends BasicChartComponent {

  private backgroundGroup;
  private slide01Group;
  private slide01ContentGroup;
  private slide02Group;
  private slide02ContentGroup;
  private slide03Group;
  private slide03ContentGroup;

  private fontFamTitle = 'Soho, Soho W01 Medium';
  private fontFamText = 'Akko, Akko W01 Regular';

  constructor(
    public iconService: IconService,
  ) {
    super(iconService);
    this.paramObject = {
      'social': paramsSocial,
    };
  }

  public async calculateValues() {
    super.calculateValues();
    this.createLineScales(this.data, this.values);
  }

  public async createElements() {

    this.slide01Group = this.host.select('#slide-01');
    this.slide01ContentGroup = this.host.select('#slide-01-content');
    this.slide01ContentGroup.selectAll('*').remove();
    this.drawSlideLineHorSteps(this.slide01ContentGroup, this.values, this.data);

    this.slide02Group = this.host.select('#slide-02');
    this.slide02ContentGroup = this.host.select('#slide-02-content');
    this.slide02ContentGroup.selectAll('*').remove();
    this.drawTextSlideWithTitle(this.slide02ContentGroup, this.values);

    this.slide03Group = this.host.select('#slide-03');
    this.slide03ContentGroup = this.host.select('#slide-03-content');
    this.slide03ContentGroup.selectAll('*').remove();
    this.drawLogoSlideCBS(this.slide03ContentGroup, this.values);
  }

  public async createAnimation(noAnimation: boolean = false) {
    let p = k => this.parameters[k];
    let v = k => this.values[k];

    let main = new TimelineMax({ repeat: -1 });
    if (!noAnimation) {

      let slide01AnimationTotal = new TimelineMax();

      // slide 1

      let stepsAnimation = new TimelineMax();
      this.animateSteps(stepsAnimation, this.values);
      this.animateUnit(stepsAnimation, this.values);
      slide01AnimationTotal.add(stepsAnimation);

      let legendAnimation = new TimelineMax();
      this.animateLegend(legendAnimation, this.values);
      slide01AnimationTotal.add(legendAnimation);

      let linesAnimation = new TimelineMax();
      this.animateNLines(linesAnimation, this.values, this.data);
      slide01AnimationTotal.add(linesAnimation);

      let pauseSlide1 = new TimelineMax()
        .set({}, {}, 'positionForStill')
        .set({}, {}, 1)
        .duration(this.timings['pauseSlide1']);
      slide01AnimationTotal.add(pauseSlide1);


      let slide1Animation = new TimelineMax();
      slide1Animation.to(this.slide01Group.node(), 1, { x: -this.values['width'] }, 'startSlide01Animation');
      slide01AnimationTotal.add(slide1Animation);

      slide01AnimationTotal.duration(this.timings['slide1Animation']);
      main.add(slide01AnimationTotal);

      // slide 2
      let slide02AnimationTotal = new TimelineMax();
      let pauseSlide2 = new TimelineMax()
        .set({}, {}, 1)
        .duration(this.timings['pauseSlide2']);
      slide02AnimationTotal.add(pauseSlide2);
      let slide02Animation = new TimelineMax();
      slide02Animation.duration(this.timings['slide02Animation']);
      slide02Animation.to(this.slide02Group.node(), 1, { x: -this.values['width'] }, 'startSlide02Animation');
      slide02AnimationTotal.add(slide02Animation);
      main.add(slide02AnimationTotal);

      // slide 3
      let slide03AnimationTotal = new TimelineMax();
      // Logo animation
      let logoCBSAnimation = new TimelineMax();
      this.animateCBSLogoAppearOneAtATime(logoCBSAnimation);
      logoCBSAnimation.duration(this.timings['logoCBSAnimation']);
      // this.animateCBSLogoAppearAllAtOnce(logoCBSAnimation);
     // this.animateCBSLogoZoomOneAtATime(logoCBSAnimation);
      slide03AnimationTotal.add(logoCBSAnimation);
      // Payoff animation
      let payoffCBSAnimation = new TimelineMax();
    //  this.animateCBSPayoffSlideIn(payoffCBSAnimation, this.values);
      this.animateCBSPayoffAppear(payoffCBSAnimation, this.values);
      payoffCBSAnimation.duration(this.timings['payoffCBSAnimation']);
      slide03AnimationTotal.add(payoffCBSAnimation);
      // Pause
      // let pauseLogoCBS = new TimelineMax()
      //   .set({}, {}, 1)
      //   .duration(this.timings['pauseCBS']);
      // slide03AnimationTotal.add(pauseLogoCBS);

      main.add(slide03AnimationTotal);

      let pauseAnimation = new TimelineMax()
        .set({}, {}, 1)
        .duration(this.timings['pauseEnd']);
      main.add(pauseAnimation);
    }

    this.animation = main;
    return this.animation;
  }

  public drawLogoSlideCBS(selection, values) {
    this.backgroundLogo(selection, values);
    this.drawCBSLogo(selection, values);
    this.drawCBSPayoff(selection, values);
  }

  public backgroundLogo (selection, values) {
    selection.append('rect')
      .attr('x', 0)
      .attr('y', 0)
      .attr('width', values['width'])
      .attr('height', values['height'])
      .attr('fill', this.lightenDarkenColor(values['colorScheme']['value'][0], -20))
      .attr('stroke', 'none');
  }

  public drawCBSLogo(selection, values) {
    const logoWidth = 104;
    const logoHeight = 156;
    let factor;
    if (values['cbsLogoWidth']) {
      factor = values['cbsLogoWidth'] / logoWidth;
    } else if (values['cbsLogoHeight']) {
      factor = values['cbsLogoHeight'] / logoHeight;
    } else {
      factor = 1;
    }

    let outerGroup = selection.append('g')
      .attr('id', `cbs-logo-outer-group-${this.id}`)
      .attr('transform', `translate(${values['width'] / 2 - values['cbsLogoWidth'] / 2} ${values['cbsLogoY']})`);
      // .attr('transform', `translate(${values['cbsLogoX']} ${values['cbsLogoY']})`);
    let innerGroup = outerGroup.append('g')
      .attr('id', `cbs-logo-inner-group-${this.id}`)
      .attr('transform', `scale(${factor} ${factor})`);
    // let test = selection.append('rect')
    //   .attr('x', values['cbsLogoX'])
    //   .attr('y', values['cbsLogoY'])
    //   .attr('width', values['cbsLogoWidth'])
    //   .attr('height', factor * logoHeight)
    //   .attr('fill', 'red');
    let c = innerGroup.append('path')
      .attr('id', `cbs-logo-c-${this.id}`)
      .attr('fill', values['cbsLogoColor'])
      .attr('d', 'M41.3,34.1V42H23.8h-5.5v5.5v7.9v5.5h5.5h17.5v7.9H10.4V34.1H41.3M46.8,28.6H9.9c-2.8,0-5,2.2-5,5v40.6h41.9V55.3h-23v-7.9h23V28.6L46.8,28.6z');
    let b = innerGroup.append('path')
      .attr('id', `cbs-logo-b-${this.id}`)
      .attr('fill', values['cbsLogoColor'])
      .attr('d', 'M67.3,11.4v17.2v5.5h5.5h21.3v34.6H59.4V11.4H67.3 M67.2,60.8h5.5h7.9h5.5v-5.5v-7.9v-5.5h-5.5h-7.9h-5.5v5.5v7.9V60.8 M67.8,5.9H53.9v68.3h45.7V33.6c0-2.8-2.2-5-5-5H72.8V11.2C72.8,8.4,70.5,5.9,67.8,5.9L67.8,5.9z M72.7,55.3v-7.9h7.9v7.9H72.7L72.7,55.3z');
    let s = innerGroup.append('path')
      .attr('id', `cbs-logo-s-${this.id}`)
      .attr('fill', values['cbsLogoColor'])
      .attr('d', 'M94,86.8v8H23.8h-5.5v5.5v7v5.5h5.5H94v33.9H10.4v-7.9h70.3h5.5v-5.5v-7.1v-5.5h-5.5H10.4V86.8H94M99.5,81.3H4.9v44.9h75.8v7.1H4.9v13.9c0,2.8,2.2,5,5,5h84.6c2.8,0,5-2.2,5-5v-39.9H23.8v-7h75.7V81.3L99.5,81.3z');
    return outerGroup;
  }

  public drawCBSPayoff(selection, values) {
    let group = selection.append('g')
      .attr('id', `cbs-logo-payoff-group-${this.id}`);
    let text = group.append('text')
      .attr('id', `cbs-logo-payoff-text-${this.id}`)
      .attr('font-family',  this.fontFamText)
      .attr('x', values['width'] / 2)
      // .attr('x', values['cbsPayoffX'])
      .attr('y', values['cbsPayoffY'])
      .attr('font-size', values['cbsPayoffFontSize'])
      .attr('fill', values['cbsPayoffFontColor'])
      .attr('text-anchor', `middle`);
    text.append('tspan')
      .attr('id', `cbs-logo-payoff-tspan1-${this.id}`)
      .attr('font-weight', 300)
      .text('Voor wat er ');
    text.append('tspan')
      .attr('id', `cbs-logo-payoff-tspan2-${this.id}`)
      .attr('font-weight', 500)
      .text('feitelijk');
    text.append('tspan')
      .attr('id', `cbs-logo-payoff-tspan3-${this.id}`)
      .attr('font-weight', 300)
      .text(' gebeurt');
    return group;
  }

  public drawSlideLineHorSteps(selection, values, data) {
    this.drawBackground(selection, values);
    this.drawTitleText1(selection, values, this.fontFamTitle );
    this.drawTitleText2(selection, values, this.fontFamTitle);
    this.drawSteps(selection, values, data);
    this.drawUnitTextSteps(selection, values);
    this.drawXAxisSteps(selection, values, data);
    this.drawXAxisLabels(selection, values);
    this.drawNLines(selection, values, data);
  }

  public drawTextSlideWithTitle(selection, values) {
    this.drawBackground(selection, values);
    this.drawTitleText1(selection, values, this.fontFamTitle);
    this.drawTitleText2(selection, values, this.fontFamTitle);
    this.drawText(selection, values);
    this.drawSVGIcon(selection, values)
  }

  public drawText(selection, values) {
    let singleReturn = /\r\n|\n|\f/g;
    let lines = values['text'].split(singleReturn);
    let rowNumber = lines.length;
    let lineHeight = values['textFontSize'] * values['textLineHeight'];
    let height = rowNumber * lineHeight;
    // let y = values['height'] / 2 - height / 2; // Deze is geschikt voor uitlijnen in het midden
    let y =  values['chartDomainY'];
    let text = selection.append('text')
      .attr('x', values['marginLeft'])
      .attr('y', y)
      .attr('dominant-baseline', 'hanging')
      .attr('fill', values['textFontColor'])
      .attr('font-size', values['textFontSize'])
      .attr('font-family', this.fontFamText)
      .attr('text-anchor', 'start');

    _.map(lines, (line, index) => {
      text.append('tspan')
        .attr('x', values['marginLeft'])
        .attr('y', y + index * lineHeight)
        .text(line);
    });
  }

  public animateCBSLogoAppearOneAtATime(timeline, values?) {
    timeline.from(`#cbs-logo-c-${this.id}`, 1, { opacity: 0 }, 'startAppearCBSLogoC');
    timeline.from(`#cbs-logo-b-${this.id}`, 1, { opacity: 0 }, 'startAppearCBSLogoB');
    timeline.from(`#cbs-logo-s-${this.id}`, 1, { opacity: 0 }, 'startAppearCBSLogoS');
  }

  public animateCBSLogoAppearAllAtOnce(timeline, values?) {
    timeline.from(`#cbs-logo-c-${this.id}`, 1, { opacity: 0 }, 'startAppearCBSLogoAll');
    timeline.from(`#cbs-logo-b-${this.id}`, 1, { opacity: 0 }, 'startAppearCBSLogoAll');
    timeline.from(`#cbs-logo-s-${this.id}`, 1, { opacity: 0 }, 'startAppearCBSLogoAll');
  }

  public animateCBSLogoZoomOneAtATime(timeline, values?) {
    timeline.from(`#cbs-logo-c-${this.id}`, 1, { scale: 0, transformOrigin: '100% 100%' }, 'startZoomCBSLogoC');
    timeline.from(`#cbs-logo-b-${this.id}`, 1, { scale: 0, transformOrigin: '0% 100%' }, 'startZoomCBSLogoB');
    timeline.from(`#cbs-logo-s-${this.id}`, 1, { scale: 0, transformOrigin: '50% 0%' }, 'startZoomCBSLogoS');
  }

  public animateCBSPayoffSlideIn(timeline, values) {
    timeline.from(`#cbs-logo-payoff-text-${this.id}`, 1, { x: -values['width'] }, 'startSlideInCBSPayoff');
  }

  public animateCBSPayoffAppear(timeline, values) {
    timeline.from(`#cbs-logo-payoff-text-${this.id}`, 1, { opacity: 0 }, 'startAppearCBSPayoff');
  }

  public animateStatbelLogoAppearAndScaleBarsOneAtATime(timeline, values?) {
    timeline.from(`#statbel-logo-text-group-${this.id}`, 1, { opacity: 0 }, 'startAppearStatbelLogoText');

    timeline.from(`#statbel-logo-bars-ltr-${this.id}`, 1, { scaleY: 0, transformOrigin: '50% 100%' }, 'startAppearStatbelLogoBars01');
    timeline.from(`#statbel-logo-bars-lbr-${this.id}`, 1, { scaleY: 0, transformOrigin: '50% 0%' }, 'startAppearStatbelLogoBars01');
    timeline.from(`#statbel-logo-bars-rtl-${this.id}`, 1, { scaleY: 0, transformOrigin: '50% 100%' }, 'startAppearStatbelLogoBars01');
    timeline.from(`#statbel-logo-bars-rbl-${this.id}`, 1, { scaleY: 0, transformOrigin: '50% 0%' }, 'startAppearStatbelLogoBars01');

    timeline.from(`#statbel-logo-bars-ltm-${this.id}`, 1, { scaleY: 0, transformOrigin: '50% 100%' }, 'startAppearStatbelLogoBars02');
    timeline.from(`#statbel-logo-bars-lbm-${this.id}`, 1, { scaleY: 0, transformOrigin: '50% 0%' }, 'startAppearStatbelLogoBars02');
    timeline.from(`#statbel-logo-bars-rtm-${this.id}`, 1, { scaleY: 0, transformOrigin: '50% 100%' }, 'startAppearStatbelLogoBars02');
    timeline.from(`#statbel-logo-bars-rbm-${this.id}`, 1, { scaleY: 0, transformOrigin: '50% 0%' }, 'startAppearStatbelLogoBars02');

    timeline.from(`#statbel-logo-bars-ltl-${this.id}`, 1, { scaleY: 0, transformOrigin: '50% 100%' }, 'startAppearStatbelLogoBars03');
    timeline.from(`#statbel-logo-bars-lbl-${this.id}`, 1, { scaleY: 0, transformOrigin: '50% 0%' }, 'startAppearStatbelLogoBars03');
    timeline.from(`#statbel-logo-bars-rtr-${this.id}`, 1, { scaleY: 0, transformOrigin: '50% 100%' }, 'startAppearStatbelLogoBars03');
    timeline.from(`#statbel-logo-bars-rbr-${this.id}`, 1, { scaleY: 0, transformOrigin: '50% 0%' }, 'startAppearStatbelLogoBars03');
  }

  public animateStatbelLogoAppearAndScaleBarsAllAtOnce(timeline, values?) {
    timeline.from(`#statbel-logo-text-group-${this.id}`, 1, { opacity: 0 }, 'startAppearStatbelLogoText');

    timeline.from(`#statbel-logo-bars-ltr-${this.id}`, 1, { scaleY: 0, transformOrigin: '50% 100%' }, 'startAppearStatbelLogoBars');
    timeline.from(`#statbel-logo-bars-lbr-${this.id}`, 1, { scaleY: 0, transformOrigin: '50% 0%' }, 'startAppearStatbelLogoBars');
    timeline.from(`#statbel-logo-bars-rtl-${this.id}`, 1, { scaleY: 0, transformOrigin: '50% 100%' }, 'startAppearStatbelLogoBars');
    timeline.from(`#statbel-logo-bars-rbl-${this.id}`, 1, { scaleY: 0, transformOrigin: '50% 0%' }, 'startAppearStatbelLogoBars');

    timeline.from(`#statbel-logo-bars-ltm-${this.id}`, 1, { scaleY: 0, transformOrigin: '50% 100%' }, 'startAppearStatbelLogoBars');
    timeline.from(`#statbel-logo-bars-lbm-${this.id}`, 1, { scaleY: 0, transformOrigin: '50% 0%' }, 'startAppearStatbelLogoBars');
    timeline.from(`#statbel-logo-bars-rtm-${this.id}`, 1, { scaleY: 0, transformOrigin: '50% 100%' }, 'startAppearStatbelLogoBars');
    timeline.from(`#statbel-logo-bars-rbm-${this.id}`, 1, { scaleY: 0, transformOrigin: '50% 0%' }, 'startAppearStatbelLogoBars');

    timeline.from(`#statbel-logo-bars-ltl-${this.id}`, 1, { scaleY: 0, transformOrigin: '50% 100%' }, 'startAppearStatbelLogoBars');
    timeline.from(`#statbel-logo-bars-lbl-${this.id}`, 1, { scaleY: 0, transformOrigin: '50% 0%' }, 'startAppearStatbelLogoBars');
    timeline.from(`#statbel-logo-bars-rtr-${this.id}`, 1, { scaleY: 0, transformOrigin: '50% 100%' }, 'startAppearStatbelLogoBars');
    timeline.from(`#statbel-logo-bars-rbr-${this.id}`, 1, { scaleY: 0, transformOrigin: '50% 0%' }, 'startAppearStatbelLogoBars');
  }
}



// WEBPACK FOOTER //
// ./src/app/animations/triptych-line-hor-steps/triptych-line-hor-steps.component.ts